
import React from 'react';
import { AccountItem } from '../data/chartData';

interface AccountListItemProps {
  account: AccountItem;
}

export const AccountListItem = ({ account }: AccountListItemProps) => {
  return (
    <div className="flex justify-between items-center py-1 border-b">
      <div className="flex gap-2">
        <span className="text-muted-foreground">{account.id}</span>
        <span>{account.name}</span>
      </div>
      <span className="font-medium">₹{account.balance.toLocaleString('en-IN')}</span>
    </div>
  );
};
